export default "<header class=\"pb__admin-page-header\">\n  <h2 class=\"pb__main-section--header\"><ng-content></ng-content></h2>\n</header>\n"